@if (showLiveModeOptions && !showPlaybackModeOptions) {
  <div
    class="modal-header text-white d-flex align-items-center justify-content-between">
    <h5 class="modal-title mb-0">Live Mode Menu</h5>
    <div class="d-flex align-items-center gap-3">
      <button class="btn text-white hm-button" (click)="goHome()" title="Home">
        <i class="fa fa-home"></i>
      </button>
      <button type="button" class="close-button" aria-label="Close" (click)="activeModal.dismiss()">×</button>
    </div>
  </div>
}
@if (!showLiveModeOptions && showPlaybackModeOptions) {
  <div
    class="modal-header text-white d-flex align-items-center justify-content-between">
    <h5 class="modal-title mb-0">Playback Mode Menu</h5>
    <div class="d-flex align-items-center gap-3">
      <button class="btn text-white hm-button" (click)="goHome()" title="Home">
        <i class="fa fa-home"></i>
      </button>
      <button type="button" class="close-button" aria-label="Close" (click)="activeModal.dismiss()">×</button>
    </div>
  </div>
}

<div class="modal-body">
  <ng-template #recursiveList let-nodes>
    @for (node of filterNodes(nodes); track node) {
      <li>
      <div class="d-flex align-items-center tree-node cursor-pointer" [ngClass]="{
              'tree-year': !node.child,
              'tree-event': node.child,
              'selected-tree-node': selectedEventId && node.event?.id === selectedEventId
            }" (click)="node.child ? setSelectedEvent(node) : (node.expanded = !node.expanded)">
          @if (node.children && node.children.length) {
            <span
              (click)="node.expanded = !node.expanded; $event.stopPropagation();"
              class="tree-toggle">
              <i class="fa" [ngClass]="node.expanded ? ' fa-angle-down' : ' fa-angle-right'"></i>
            </span>
          }
          <span class="tree-name">
            {{ node.name }}
            @if (!node.child) {
              <span class="text-dark">({{ node.count }})</span>
            }
          </span>
        </div>
        @if (node.children && node.children.length && node.expanded) {
          <ul class="list-unstyled ps-3 tree-children">
            <ng-container *ngTemplateOutlet="recursiveList; context:{ $implicit: node.children }"></ng-container>
          </ul>
        }
      </li>
    }
  </ng-template>
  @if (showLiveModeOptions && !playbackDataLoaded) {
    <div>
      Loading Data. Please wait...
    </div>
  }

  @if (showLiveModeOptions && playbackDataLoaded) {
    <div>
      <h5 class="mb-3">Select an Incident</h5>
      <div class="row">
        <div class="col-md-4 fs-5 fw-bold mb-2">Organizations</div>
      </div>
      <div class="row">
        <div class="col-lg-4">
          <div class="list-group incident-table p-1 org-list-border">
            <table class="table  table-hover">
              <tbody>
                @for (item of orgsSorted; track item) {
                  <tr>
                    <td (click)="setSelectedOrg(item)" [ngClass]="{'selected_table_item': item === selectedOrg}">
                      {{ item.name }}
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
        <div class="col-lg-8">
          <ul class="nav nav-pills mb-3 d-flex nav-head cursor-pointer">
            <li [class.active]="activeTab === 'liveIncidentsTab'" (click)="activeTab = 'liveIncidentsTab'"
              class="nav-link text-center nav-border flex-fill">
              <a>Incidents</a>
            </li>
            <!-- remove procalls section -->
            <li [class.active]="activeTab === 'liveProcallsTab'" (click)="activeTab = 'liveProcallsTab'"
              class="nav-link text-center nav-border flex-fill d-none">
              <a>Procalls</a>
            </li>
            <li [class.active]="activeTab === 'liveTrackingTab'" (click)="activeTab = 'liveTrackingTab'"
              class="nav-link text-center nav-border flex-fill">
              <a>Tracking Events</a>
            </li>
          </ul>
          <div class="tab-content">
            @if (activeTab === 'liveIncidentsTab') {
              <div class="tab-pane in active">
                <div class="incident-table">
                  <table class="table table-striped table-hover">
                    @if (selectedOrg) {
                      <tbody>
                        @for (event of filterIncidentsByMode(getIncidentEvents(), 'Live Mode'); track event) {
                          <tr>
                            <td (click)="setSelectedEvent(event)" [ngClass]="{'selected_table_item': event === selectedEvent}">
                              <span>{{ event.name || event.getName?.() || '' }} </span><span>{{ formatEventDate(event.createdAt)
                            }}</span>
                          </td>
                        </tr>
                      }
                    </tbody>
                  }
                </table>
              </div>
            </div>
          }
          @if (activeTab === 'liveProcallsTab') {
            <div class="tab-pane in">
              <div class="incident-table">
                <table class="table table-striped table-hover">
                  @if (selectedOrg) {
                    <tbody>
                      @for (event of filterProcallsByMode(getProcallEvents(), 'Live Mode'); track event) {
                        <tr>
                          <td (click)="setSelectedEvent(event)" [ngClass]="{'selected_table_item': event === selectedEvent}">
                            <span>{{ event.name || event.getName?.() || '' }} </span><span>{{ formatEventDate(event.createdAt)
                          }}</span>
                        </td>
                      </tr>
                    }
                  </tbody>
                }
              </table>
            </div>
          </div>
        }
        @if (activeTab === 'liveTrackingTab') {
          <div class="tab-pane in">
            <div class="incident-table">
              <table class="table table-striped table-hover">
                @if (selectedOrg) {
                  <tbody>
                    @for (event of filterTrackingByMode(getTrackingEvents(), 'Live Mode'); track event) {
                      <tr>
                        <td (click)="setSelectedEvent(event)" [ngClass]="{'selected_table_item': event === selectedEvent}">
                          <span>{{ event.name || event.getName?.() || '' }} </span><span>{{ formatEventDate(event.createdAt)
                        }}</span>
                      </td>
                    </tr>
                  }
                </tbody>
              }
            </table>
          </div>
        </div>
      }
    </div>
  </div>
</div>
</div>
}
@if (showPlaybackModeOptions && !playbackDataLoaded) {
  <div>
    Loading Playback Data. Please wait...
  </div>
}
@if (showPlaybackModeOptions && playbackDataLoaded) {
  <div>
    <h5 class="mb-3">Select an Incident</h5>
    <div class="row">
      <div class="col-md-4 fs-5 fw-bold mb-2">Organizations</div>
      <div class="col-md-1 d-flex justify-content-center m-0 p-0"><i class="fa fa-search mt-2"></i></div>
      <div class="col-md-7">
        <div class="input-group mb-2">
          <input type="text" class="form-control" placeholder="Search here..." [(ngModel)]="searchText" />
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-4">
        <div class="list-group incident-table p-1 org-list-border">
          <table class="table  table-hover">
            <tbody>
              @for (item of orgsSorted; track item) {
                <tr class="border-none">
                  <td (click)="setSelectedOrg(item)" [ngClass]="{'selected_table_item': item === selectedOrg}">
                    {{ item.name }}
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-lg-8">
        <ul class="nav nav-pills mb-3 d-flex nav-head cursor-pointer">
          <li [class.active]="activeTab === 'incidents'" class="nav-link text-center nav-border flex-fill"
            (click)="activeTab = 'incidents'"><a>Incidents</a></li>
            <!-- remove procalls section -->
            <li [class.active]="activeTab === 'procalls'" class="nav-link text-center nav-border flex-fill d-none"
              (click)="activeTab = 'procalls'"><a>Procalls</a></li>
              <li [class.active]="activeTab === 'tracking'" class="nav-link text-center nav-border flex-fill"
                (click)="activeTab = 'tracking'"><a>Tracking Events</a></li>
              </ul>
              <div class="tab-content">
                @if (activeTab === 'incidents') {
                  <div class="tab-pane in active">
                    <div class="incident-table">
                      @if (currentIncidentPlaybackTree) {
                        <ul class="tree-light list-unstyled ps-0">
                          <ng-container
                          *ngTemplateOutlet="recursiveList; context:{ $implicit: currentIncidentPlaybackTree }"></ng-container>
                        </ul>
                      }
                    </div>
                  </div>
                }
                @if (activeTab === 'procalls') {
                  <div class="tab-pane in active">
                    <div class="incident-table">
                      @if (currentProcallPlaybackTree) {
                        <ul class="tree-light list-unstyled ps-0">
                          <ng-container
                          *ngTemplateOutlet="recursiveList; context:{ $implicit: currentProcallPlaybackTree }"></ng-container>
                        </ul>
                      }
                    </div>
                  </div>
                }
                @if (activeTab === 'tracking') {
                  <div class="tab-pane in active">
                    <div class="incident-table">
                      @if (currentTrackingPlaybackTree) {
                        <ul class="tree-light list-unstyled ps-0">
                          <ng-container
                          *ngTemplateOutlet="recursiveList; context:{ $implicit: currentTrackingPlaybackTree }"></ng-container>
                        </ul>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="modal-footer">
      @if (showLiveModeOptions) {
        <div class="text-center">
          <button type="button" class="btn btn-default" (click)="liveEventClicked()"
          [disabled]="!selectedOrg || !selectedEvent">Open</button>
        </div>
      }
      @if (showPlaybackModeOptions) {
        <div class="text-center">
          <button type="button" class="btn btn-default" (click)="playbackEventClicked()"
          [disabled]="!selectedOrg || !selectedEvent">Playback</button>
        </div>
      }
      <button class="btn btn-outline-primary" (click)="activeModal.dismiss()">Cancel</button>
    </div>